import { Link } from 'react-router-dom';
import { useTheme } from '../shared/theme/ThemeContext';
import { pageShellClass } from '../shared/theme/themeStyles';
import SflmaExplorer from './SflmaExplorer';

/** Nationwide candidate explorer. No account, and no farm tools. */
export default function PublicSflmaPage() {
  const { theme, isDark } = useTheme();

  return (
    <div className={`flex h-screen flex-col ${pageShellClass(theme)}`}>
      <header
        className={`flex items-center justify-between gap-3 border-b px-4 py-2.5 ${
          isDark ? 'border-[#2d3748]' : 'border-[#e5e7eb]'
        }`}
      >
        <div className="min-w-0">
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#008540]">Digisaka</p>
          <p className={`truncate text-sm ${isDark ? 'text-[#8b949e]' : 'text-[#6b7280]'}`}>
            Public preview · no login needed
          </p>
        </div>
        <Link
          to="/userdashboard"
          className="shrink-0 rounded-lg bg-[#008540] px-3 py-1.5 text-sm font-semibold text-white"
        >
          Log in
        </Link>
      </header>
      <SflmaExplorer publicPreview />
    </div>
  );
}
